import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './state/auth'
import Login from './pages/Login'
import Register from './pages/Register'
import Projects from './pages/Projects'
import Project from './pages/Project'

function Protected({ children }) {
    const token = useAuth(s => s.token)
    if (!token) return <Navigate to="/login" replace />
    return children
}

function ProtectedUserLogged({ children }) {
    const token = useAuth(s => s.token)
    if (token) return <Navigate to="projects" replace />
    return children
}

export default function App() {
    const token = useAuth(s=>s.token)
    const hydrateMe = useAuth(s=>s.hydrateMe)
    useEffect(()=>{ if (token) hydrateMe().catch(()=>{}) },[token,hydrateMe])
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<ProtectedUserLogged><Login/></ProtectedUserLogged>} />
                <Route path="/register" element={<ProtectedUserLogged><Register/></ProtectedUserLogged>} />
                <Route path="/projects" element={<Protected><Projects/></Protected>} />
                <Route path="/projects/:id" element={<Protected><Project/></Protected>} />
                <Route path="*" element={<Navigate to="/projects" replace/>} />
            </Routes>
        </BrowserRouter>
    )
}
